import { fixFailedToExecuteRemoveChildOnNode } from '@systemeio/util'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import App from './App'
import './i18'
import './index.css'
import '../../../../styles/colors.css'
import { configureStore } from './store'
import { parseUrl } from './utils/getIdFromUrl'
import { applyBrand, getBrand } from './utils/brand/get-brand'

fixFailedToExecuteRemoveChildOnNode()

//
;(async () => {
  const { id, isTemplate } = parseUrl()

  const rootElement = document.getElementById('root')

  if (!rootElement) throw new Error('Failed to find the root element')

  const root = createRoot(rootElement)

  root.render(<div>Loading...</div>)

  const brand = await getBrand(true)

  if (!brand) {
    root.render(<div>Something went wrong</div>)
  }

  applyBrand(brand)

  if (!id) {
    root.render(<div>Not found</div>)
  } else {
    root.render(
      <React.Suspense fallback="loading">
        <Provider store={configureStore()}>
          <App id={id} isTemplate={isTemplate} />
        </Provider>
      </React.Suspense>,
    )
  }
})()
